import { useEffect, useRef, useState } from 'react'
import { CourseState } from '../../Course/CourseState'
import { useCourseStore } from '../../Course/CourseStore'
import { Angles } from '../../Util/Math/Angles'
import { Coordinates } from '../../Util/Math/Coordinates'
import './notecircle.scss'
import { TransformTranslate } from '../../Util/Transform/Transform'
import { useNoteNames } from '../../Project/ProjectStore'
export interface NoteCircleProps{
    radius:number
    step?:number
    referenceNote?:number
    hilitedNotes?:number[]
    selectedNotes?:number[]
    caption?:string
    onNoteClick?:Function
    height:number
    width:number
    rotation?:number
}
export function getNoteCircleRadius(radius:number){
    return radius * .22
}
export function NoteCircle(props:NoteCircleProps){
    const h:number = props.height + 5
    return <svg className={'note-circle'} width={props.width} height={h}>
               <g transform={TransformTranslate(props.width/2, h/2)} className={'note-circle-container'}>
                    <NoteCircleGroup {...props}/>
                </g>
            </svg>
}
export function NoteCircleGroup(props:NoteCircleProps){
    const isExternallyDriven:boolean = (props.hilitedNotes) ? true : false
    const noteNames:string[] = useNoteNames()
    const baseRotation:number = 90
    const getBaseRotation = () => {
        if(props.rotation) return props.rotation
        return baseRotation
        //return (baseRotation + ((props.hilitedNote * 30)))
    }
    const [rotation, setRotation] = useState(getBaseRotation())
    const getInitialHilitedNotes = () => {
        if(props.hilitedNotes){return props.hilitedNotes}
        return []
    }
    const getInitialSelectedNotes = () => {
        if(props.selectedNotes){return props.selectedNotes}
        return []
    }
    const getHilitedNotes = () => {
        if(isExternallyDriven && props.hilitedNotes){
            return props.hilitedNotes
        }
        return hilitedNotes
    }
    const getSelectedNotes = () => {
        if(isExternallyDriven && props.selectedNotes){
            return props.selectedNotes
        }
        return selectedNotes
    }
    const [hilitedNotes, setHilitedNotes] = useState(getInitialHilitedNotes())
    const [selectedNotes, setSelectedNotes] = useState(getInitialSelectedNotes())
    const initRotated = useRef(false)
    const tweenObj:any = useRef({r: rotation})

    const rotate = function(n:number){
        let startRotation = rotation
        let endRotation = (baseRotation + (n * 30)) % 360
        const delta:number = endRotation - rotation
        // change directions if rotation is more than half the circle
        if(delta < -180){ startRotation -= 360}
        if(delta > 180){ startRotation += 360}
        setRotation(rotation + delta)
    }
    const onElementClick = function(elementIndex:number){
        if(isExternallyDriven && !props.onNoteClick){
            return
        }
        if(props.onNoteClick){
            props.onNoteClick(elementIndex)
        }
        const hilites:number[] = hilitedNotes.concat()
        const index:number = hilites.indexOf(elementIndex)
        if(index < 0){ hilites.push(elementIndex) }
        else{ hilites.splice(index, 1) }
        setHilitedNotes(hilites)
    }
    const buildNotes = function(){
        let notes:JSX.Element[] = []
        const step:number = (props.step) ? props.step : 1
        const radius:number = getNoteCircleRadius(props.radius)
        for(let i:number = 0; i < 12; i++){
            const adjustedPosition:number = (i * step) % 12
            let angleInDegrees:number = ((-30 * adjustedPosition) + rotation) % 360
            let angleInRadians:number = Angles.degreesToRadians(angleInDegrees)
            let x:number = props.radius * Math.sin(angleInRadians)
            let y:number = props.radius * Math.cos(angleInRadians)
            let c:Coordinates = new Coordinates(x,y)
            const note:string = noteNames[i % 12]
            const hilite:boolean = getHilitedNotes().includes(i)
            const selected:boolean = getSelectedNotes().includes(i)
            const isTopNote:boolean = (i === props.referenceNote)
            let e:JSX.Element = <NoteCircleElement  
                                    key={i + Date.now()} 
                                    note={note} 
                                    coordinates={c} 
                                    index={i} 
                                    onClick={onElementClick}
                                    hilite={hilite}
                                    selected={selected}
                                    isTopNote={isTopNote}
                                    noteCircleRadius={radius}
                                />
            notes.push(e)
        }
        return notes
    }
    let notes = buildNotes()
    const caption = (props.caption) ? props.caption : 'clear'
    const clearHilites = () => {
        setHilitedNotes([])
    }
    return <g className='note-circle-group'>
                <g className={'note-circle-inner'}>{notes}</g> 
                <text transform={TransformTranslate(0, 10)} onClick={clearHilites} className='note-circle-caption'>{'clear'}</text>
            </g>
}
export interface NoteCircleElementProps{
    noteCircleRadius:number
    coordinates:Coordinates
    index:number
    onClick:Function
    note:string
    hilite:boolean
    selected:boolean
    isTopNote:boolean
}
export function NoteCircleElement(props:NoteCircleElementProps){
    const radius:number = props.noteCircleRadius
    let transform:string = "translate(" + props.coordinates.toStringPoints() + ")"
    let className:string = 'note-circle-element shadow '
    if(props.hilite === true) className += ' hilite'
    if(props.selected === true && !props.hilite) className += ' selected'
    if(props.isTopNote === true) className += ' topnote'
    return <g onClick={(e:React.MouseEvent)=>{e.stopPropagation(); props.onClick(props.index)}} transform={transform} className={className}>
                <circle r={radius}/>
                <text fontSize={radius * 1}>{props.note}</text>
            </g>
}
export function CircleOfFifths(props:NoteCircleProps){
    return <NoteCircle rotation={150} onNoteClick={props.onNoteClick} selectedNotes={props.selectedNotes} hilitedNotes={props.hilitedNotes} radius={props.radius} caption={''} step={7} height={props.height} width={props.width}/>
}


